import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const RoxburghParkCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Roxburgh Park" suburbSlug="roxburgh-park" variant="cdbs-dentist" />
);

export default RoxburghParkCdbsDentistPage;
